import React from 'react';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';

class ErrorRecap extends React.Component {
	render() {
		return (
			<Alert severity={this.props.critical ? "error" : "warning"}>
				<AlertTitle>{this.props.message}</AlertTitle>
				{this.props.details &&
					<ul>
						{this.props.details.map((element, index) =>
							(<li key={index}>{element}</li>)
						)}
					</ul>
				}
			</Alert>
		);
	}
}

export default ErrorRecap;